<template>
  <div>
    <v-row>
      <v-col sm="6">
        <v-btn
          :disabled="disabled"
          color="success"
          @click="showRemainsWindow"
          elevation="0"
        >
          {{ $t("goods.choose_from_remains") }}
        </v-btn>
      </v-col>
    </v-row>
    <v-form ref="goodsListForm">
      <v-data-table
        :disabled="brands.loader"
        :loading="brands.loader"
        ref="goodsItemsTable"
        :headers="goodsItemsTableHeader"
        :items="items"
        class="elevation-0 mb-3 mx-3 w-100"
        :footer-props="{
          'items-per-page-text': $t('tables.items_per_page'),
          'items-per-page-options': [
            50, 100,
            //-1
          ],
        }"
      >
        <template v-slot:footer.page-text="props">
          {{
            $t("tables.x_of_y", [
              `${props.pageStart}-${props.pageStop}`,
              props.itemsLength,
            ])
          }}
        </template>
        <template v-slot:item.amount="props">
          <amount-of-nomenclature
            :amount="props.item.amount"
            :nomenclature="props.item.nomenclature"
          />
          <nomenclature-measurement-short-name :nomenclature="props.item.nomenclature"/>
        </template>
        <template v-slot:item.price="props">
          <!--Цена-->
          {{ props.item.price }}
        </template>
        <template v-slot:item.relocation_from="props">
          <!--Откуда перемещаем -->
          <div class="text-no-wrap">
            <span v-if="props.item.storage">
              {{ props.item.storage.name }}
            </span>
            <span v-if="props.item.storage && props.item.rack">
              / {{ props.item.rack && props.item.rack.name }}</span
            >
            <span
              v-if="props.item.storage && props.item.rack && props.item.shelf"
            >
              / {{ props.item.shelf && props.item.shelf.name }}</span
            >
          </div>
        </template>
        <template v-slot:item.storage_relocation_to="props">
          <span v-if="props.item.storage_relocation_to && disabled">
            {{ props.item.storage_relocation_to.name }}
          </span>
          <v-select
            v-if="isFetchedStorages"
            v-show="!disabled"
            :disabled="disabled"
            :rules="[
              (v) => !!v || $t('form.validationErrors.field_is_required'),
            ]"
            :label="$t('viewGoods.storage')"
            :items="
              storages.filter((storage) => storage.id !== props.item.storage_id)
            "
            item-text="name"
            return-object
            class="pointer"
            clearable
            v-model="props.item.storage_relocation_to"
            @change="
              props.item.rack_relocation_to = null;
              props.item.shelf_relocation_to = null;
              changeItem($event, props.item, 'storage_relocation_to');
            "
          ></v-select>
        </template>
        <template v-slot:item.rack_relocation_to="props">
          <span
            v-if="
              disabled &&
              props.item.storage_relocation_to &&
              props.item.rack_relocation_to
            "
          >
            {{
              props.item.rack_relocation_to &&
              props.item.rack_relocation_to.name
            }}</span
          >
          <v-select
            :disabled="disabled"
            v-show="!disabled"
            v-if="
              props.item.storage_relocation_to &&
              isFetchedStorages &&
              storages &&
              storages.find(
                (s) => s.id === props.item.storage_relocation_to.id
              ) &&
              storages.find((s) => s.id === props.item.storage_relocation_to.id)
                .rack
                &&               storages.find((s) => s.id === props.item.storage_relocation_to.id)
                .rack.length >0
            "
            :label="$t('viewGoods.storage_rack')"
            :items="
              storages &&
              storages.find(
                (s) => s.id === props.item.storage_relocation_to.id
              ) &&
              storages.find((s) => s.id === props.item.storage_relocation_to.id)
                .rack
            "
            item-text="name"
            return-object
            class="pointer"
            clearable
            v-model="props.item.rack_relocation_to"
            @change="
              props.item.shelf_relocation_to = null;
              changeItem($event, props.item, 'rack_relocation_to');
            "
          ></v-select>
        </template>
        <template v-slot:item.shelf_relocation_to="props">
          <span
            v-if="
              disabled &&
              props.item.storage_relocation_to &&
              props.item.rack_relocation_to &&
              props.item.shelf_relocation_to
            "
          >
            {{
              props.item.shelf_relocation_to &&
              props.item.shelf_relocation_to.name
            }}</span
          >
          <v-select
            v-if="
              !disabled &&
              props.item.storage_relocation_to &&
              props.item.rack_relocation_to &&
              isFetchedStorages
            "
            :disabled="disabled"
            v-show="!disabled"
            :label="$t('viewGoods.storage_rack_shelve')"
            :items="
              storages
                .find((s) => s.id === props.item.storage_relocation_to.id)
                .rack.find((r) => r.id === props.item.rack_relocation_to.id)
                .shelf
            "
            item-text="name"
            return-object
            class="pointer"
            clearable
            @change="changeItem($event, props.item, 'shelf_relocation_to')"
            v-model="props.item.shelf_relocation_to"
          ></v-select>
        </template>
        <template v-slot:item.price="props">
          {{ formatCurrency(props.item.price) }}
        </template>
        <template v-slot:item.total="props">
          <span v-if="props.item.price">
            {{
              formatCurrency(roundToTwo(
                (roundToTwo(
                  parseFloat(
                    props.item.price.toString().replace(/,/g, ".") / 100
                  ) * documentTaxValue
                ) +
                  parseFloat(props.item.price.toString().replace(/,/g, "."))) *
                  parseFloat(props.item.amount.toString().replace(/,/g, "."))
              ))
            }}
          </span>
        </template>
        <template v-slot:item.actions="props">
          <span class="btn-td-wrap" v-if="!disabled">
            <v-btn
              elevation="0"
              min-width="36"
              min-height="36"
              color="red lighten-2"
              class="mb-0 ml-3 px-0 white--text"
              :title="$t('common.remove')"
              @click="remove(props.item)"
            >
              <v-icon small>$trash</v-icon>
            </v-btn>
          </span>
        </template>
        <template v-slot:no-data>
          {{ $t("common.no_data_available") }}
        </template>
        <template v-slot:no-results>
          {{ $t("common.no_data_available") }}
        </template>
      </v-data-table>
    </v-form>
    <nomenclature-form
      :id="nomenclatureWindow.id"
      :show="nomenclatureWindow.isVisible"
      :action="nomenclatureWindow.action"
      @hide="nomenclatureWindow.isVisible = false"
      @store="(items) => selectGoodsNomenclatureSearchItems(items)"
      @replace="(data) => replaceGoodsNomenclatureSearchItem(data)"
    />
    <choose-remains-form
      @choose="(items) => selectGoodsNomenclatureSearchItems(items)"
      :show="chooseRemainsWindow.isVisible"
      @hide="chooseRemainsWindow.isVisible = false"
    />
  </div>
</template>

<script>
import { mapFields } from "vuex-map-fields";
import { roundToTwo } from "@/fn/math";
import NomenclatureForm from "@/components/storage/NomenclatureForm";
import ChooseRemainsForm from "@/components/storage/ChooseRemainsForm";
import AmountOfNomenclature from "@/components/storage/AmountOfNomenclature";
import CommonMixin from "@/mixins/common";
import NomenclatureMeasurementShortName from "@/components/storage/NomenclatureMeasurementShortName.vue";

export default {
  name: "GoodsRelocationList",
  components: {NomenclatureMeasurementShortName, AmountOfNomenclature, ChooseRemainsForm, NomenclatureForm },
  mixins: [CommonMixin],
  props: {
    items: {
      type: Array,
    },
    documentTaxValue: null,
    disabled: null,
    type: {
      validator(value) {
        // The value must match one of these strings
        return [
          "goods_relocation", //перемещение
        ].includes(value);
      },
    },
  },
  data: () => ({
    findTimeoutId: null,
    chooseRemainsWindow: {
      isVisible: false,
    },
    nomenclatureWindow: {
      isVisible: false,
      action: null,
      item: null,
    },
  }),
  updated() {
    this.$nextTick(() => {
      this.emitValidate();
    });
  },
  computed: {
    ...mapFields("storages", ["storages"]),
    ...mapFields("storages", { isFetchedStorages: "fetched" }),
    ...mapFields("suppliers", ["brands"]),
    ...mapFields("goods", ["isLoadingGoodsNomenclatureSearch"]),
    goodsNomenclatureSearchItems() {
      if (this.brands && this.brands.parts && this.brands.parts.length) {
        let items = [];
        let nomenclatures = []; //найдено в номенклатуре текущего магазина
        let common_catalog = []; //найдено в API suppliers
        this.brands.parts.forEach((item) => {
          item.text = this.goodsNomenclatureSearchItemText(item);
          if (item.nomenclature_id) {
            nomenclatures.push(item);
          } else {
            if (nomenclatures.findIndex((el) => el.text === item.text) === -1) {
              common_catalog.push(item);
            }
          }
        });
        if (nomenclatures.length) {
          //добавим заголовок для найденого в номенклатуре
          items.push({
            text:
              this.brands.part_number +
              ": " +
              this.$t("viewGoods.found_in_nomenclature"),
            disabled: true,
          });
          items = items.concat(nomenclatures);
        }
        if (common_catalog.length) {
          //добавим заголовок для найденого в api suppliers
          items.push({
            text:
              this.brands.part_number +
              ": " +
              this.$t("viewGoods.found_in_common_catalog"),
            disabled: true,
          });
          items = items.concat(common_catalog);
        }
        return items;
      }
      return [];
    },
    goodsItemsTableHeader() {
      let data = [
        {
          text: this.$t("common.brand"),
          value: "brand",
          sortable: true,
          class: "text-no-wrap",
        },
        {
          class: "text-no-wrap",
          text: this.$t("common.part_code"),
          value: "part_code",
          sortable: true,
        },
        {
          text: this.$t("common.title"),
          value: "part_name",
          sortable: true,
          class: "text-no-wrap",
        },
        {
          text: this.$t("common.amount"),
          value: "amount",
          sortable: true,
          align: "end",
          width: "80px",
          class: "text-no-wrap",
        },
        {
          text: this.$t("common.price"),
          value: "price",
          align: "end",
          sortable: true,
          width: "80px",
          class: "text-no-wrap",
        },
        {
          text: this.$t("common.total_sum"),
          align: "end",
          value: "total",
          sortable: true,
          class: "text-no-wrap",
        },
        {
          text: this.$t("viewGoods.relocation_from"),
          value: "relocation_from",
          sortable: true,
          class: "text-no-wrap",
        },
        {
          text:
            this.$t("viewGoods.relocation_to") +
            ": " +
            this.$t("viewGoods.storage"),
          value: "storage_relocation_to",
          sortable: true,
          class: "text-no-wrap",
        },
        {
          text:
            this.$t("viewGoods.relocation_to") +
            ": " +
            this.$t("viewGoods.storage_rack"),
          value: "rack_relocation_to",
          sortable: false,
          class: "text-no-wrap",
        },
        {
          text:
            this.$t("viewGoods.relocation_to") +
            ": " +
            this.$t("viewGoods.storage_rack_shelve"),
          value: "shelf_relocation_to",
          sortable: false,
          class: "text-no-wrap",
        },
        {
          width: "150px",
          text: this.$t("common.actions"),
          value: "actions",
          sortable: false,
        },
      ];
      return data;
    },
  },
  watch: {
    "brands.part_number"() {
      if (this.brands.part_number === "" || this.brands.part_number === null) {
        clearTimeout(this.findTimeoutId);
        return;
      }
      clearTimeout(this.findTimeoutId);
      this.findTimeoutId = setTimeout(() => {
        this.brands.parts = [];
        this.$store.dispatch("suppliers/brandsGet", {
          with_nomenclature: true,
        });
      }, 1000);
    },
  },
  methods: {
    showRemainsWindow() {
      this.chooseRemainsWindow.isVisible = true;
    },
    emitValidate() {
      if (this.$refs && this.$refs["goodsListForm"]) {
        let isValid = this.$refs["goodsListForm"].validate();
        this.$emit("changeGoodsListValidation", isValid);
      }
    },
    roundToTwo(num) {
      return roundToTwo(num);
    },
    changeItem(value, item, param) {
      item[param] = value;
      this.$emit("change", item);
      this.emitValidate();
    },
    remove(item) {
      this.$emit("remove", item);
    },
    selectGoodsNomenclatureSearchItems(items) {
      this.brands.parts = [];
      this.$emit("add", items);
    },
    replaceGoodsNomenclatureSearchItem(item) {
      let data = {
        nomenclature: item.nomenclature,
        nomenclature_id: item.nomenclature_id ? item.nomenclature_id : null,
        brand: item.brand,
        part_code: item.part_code,
        part_name: item.name,
        amount: item.amount ? item.amount : 0,
        price: item.price ? item.price : 0,
      };
      this.$emit("replace", { to: data, from: this.nomenclatureWindow.item });
    },
    goodsNomenclatureSearchItemText(item) {
      return (
        (item.brand ? `${item.brand} ` : "") +
        (item.part_code ? `${item.part_code} ` : "") +
        (item.name ? `${item.name} ` : "")
      );
    },
  },
};
</script>

<style scoped></style>
